// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d17d442e","977":"430017a5"}[chunkId] + ".chunk.js";
};